import Season from 'app/frontend/types/custom/Season'
import { createContext, useContext } from 'react'
import { EnrichedTeamMembership } from './types'

type AuditContextType = {
  loadingAuditData: boolean
  selectedSeason: Season
  setSelectedSeason: (season: Season) => void
  visibleMembers: EnrichedTeamMembership[]
  weeksAgo: number
  setWeeksAgo: (weeksAgo: number) => void
  showingRanks: boolean
  setShowingRanks: (showingRanks: boolean) => void
  activeView: 'graph' | 'list'
  setActiveView: (activeView: 'graph' | 'list') => void
  filterOverrides?: Record<string, string | undefined>
  visibleTeamRanks: string[]
  setVisibleTeamRanks: (visibleTeamRanks: string[]) => void
  setRefreshStatusOpen: (refreshStatusOpen: boolean) => void
}

export const AuditContext = createContext<AuditContextType>({
  loadingAuditData: false,
  selectedSeason: {} as Season,
  setSelectedSeason: () => null,
  visibleMembers: [],
  weeksAgo: 0,
  setWeeksAgo: () => null,
  showingRanks: false,
  setShowingRanks: () => null,
  activeView: 'list',
  setActiveView: () => null,
  visibleTeamRanks: [],
  setVisibleTeamRanks: () => null,
  setRefreshStatusOpen: () => null,
})

export const useAudit = () => {
  const context = useContext(AuditContext)
  if (context === undefined) {
    throw new Error('useAudit must be used within a AuditProvider')
  }

  return context
}
